var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 15.8333C7.50065 16.4583 7.32565 17.05 7.01732 17.55C6.44232 18.5167 5.38398 19.1667 4.16732 19.1667C2.95065 19.1667 1.89232 18.5167 1.31732 17.55C1.00899 17.05 0.833984 16.4583 0.833984 15.8333C0.833984 13.9917 2.32565 12.5 4.16732 12.5C6.00898 12.5 7.50065 13.9917 7.50065 15.8333Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86914 15.8323L3.69414 16.6573L5.46914 15.0156",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7935 5.87432C14.5935 5.84099 14.3852 5.83267 14.1685 5.83267H5.83516C5.60182 5.83267 5.37682 5.84933 5.16016 5.88266C5.27682 5.64933 5.44349 5.43269 5.64349 5.23269L8.35182 2.51602C9.49349 1.38268 11.3435 1.38268 12.4852 2.51602L13.9435 3.99098C14.4768 4.51598 14.7602 5.18266 14.7935 5.87432Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.0007V14.1673C18.3327 16.6673 16.666 18.334 14.166 18.334H6.35768C6.61602 18.1173 6.84101 17.8506 7.01601 17.5506C7.32435 17.0506 7.49935 16.459 7.49935 15.834C7.49935 13.9923 6.00768 12.5007 4.16602 12.5007C3.16602 12.5007 2.27435 12.9423 1.66602 13.634V10.0007C1.66602 7.73398 3.03268 6.15065 5.15768 5.88398C5.37435 5.85065 5.59935 5.83398 5.83268 5.83398H14.166C14.3827 5.83398 14.591 5.84231 14.791 5.87564C16.941 6.12564 18.3327 7.71732 18.3327 10.0007Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.416H15.8327C14.916 10.416 14.166 11.166 14.166 12.0827C14.166 12.9993 14.916 13.7493 15.8327 13.7493H18.3327",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchase-order.a49f6f8814d177b858a0962bc86b6499.svg";
export { ForwardRef as ReactComponent };